<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
              class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>Agregar producto</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div class="p-6">

        <!-- Type -->
        <div>
          <label class="text-sm opacity-75">Tipo*</label>
          <v-select :options="types" :clearable="false"
                    placeholder="Selecciona"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="document.type" class="mb-4 md:mb-0" name="type" v-validate="'required'"/>
          <span class="text-danger text-sm"
                v-show="errors.has('type')">{{ errors.first('type') }}</span>
        </div>

        <!-- Number Part -->
        <vs-input @blur="document.numberPart= trimString(document.numberPart)" label="Nro. de Parte*"
                  v-model="document.numberPart"
                  class="w-full mt-5" name="numberPart"
                  v-validate="'required'"/>
        <span class="text-danger text-sm"
              v-show="errors.has('numberPart')">{{ errors.first('numberPart') }}</span>

        <!-- Description -->
        <vs-textarea rows="10" @blur="document.description= trimString(document.description)" label="Descripción*"
                     v-model="document.description"
                     class="mt-5 w-full" name="description"
                     v-validate="'required'"/>
        <span class="text-danger text-sm"
              v-show="errors.has('description')">{{ errors.first('description') }}</span>

        <!-- Purchase price -->
        <vs-input type="number" label="Precio de compra*" v-model.number="document.purchasePrice" class="mt-5 w-full"
                  name="purchasePrice"
                  v-validate="'required'"/>
        <span class="text-danger text-sm"
              v-show="errors.has('purchasePrice')">{{ errors.first('purchasePrice') }}</span>

        <!-- Price -->
        <vs-input type="number" label="Precio referencial de venta*" v-model.number="document.price" class="mt-5 w-full"
                  name="price"
                  v-validate="'required'"/>
        <span class="text-danger text-sm"
              v-show="errors.has('price')">{{ errors.first('price') }}</span>

      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid || progress">Guardar</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancelar</vs-button>
      <div v-if="progress" style="margin-top: 1rem; width: 100%">
        <vs-progress indeterminate color="primary"></vs-progress>
      </div>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import trimString from '../../mixins/trimString'
import vSelect from 'vue-select'

import { db, auth, FieldValue } from '@/firebase/firebaseConfig'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    }
  },
  components: {
    VuePerfectScrollbar,
    vSelect
  },
  mixins: [trimString],
  data () {
    return {
      document: {},
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      progress: false,
      types: [
        'Regular',
        'Servicio'
      ]
    }
  },
  watch: {
    isSidebarActive (val) {
      if (val) {
        this.document = {}
        this.$validator.reset()
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid () {
      return !this.errors.any()
    },
    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    /**
     * Save data in firestore
     * @returns {Promise<void>}
     */
    async submitData () {
      try {
        const result = await this.$validator.validateAll()
        if (result) {
          this.progress = true
          const obj = {
            stock: 0,
            ...this.document,
            state: true
          }
          obj.numberPart = obj.numberPart.toUpperCase()
          // Validate number part
          const querySnap = await db.collection('products').where('numberPart', '==', obj.numberPart).get()
          if (querySnap.size === 0) {
            const doc = await db.collection('products').add({
              ...obj,
              uid: auth.currentUser.uid,
              createdAt: FieldValue.serverTimestamp()
            })
            obj.id = doc.id
            this.$emit('add', obj)
            this.$emit('closeSidebar')
            this.progress = false
            this.$vs.notify({
              color: 'success',
              title: 'Producto',
              text: 'Producto creado correctamente.'
            })
          } else {
            this.$vs.notify({
              color: 'warning',
              title: 'Producto',
              text: 'Número de parte no puede repetirse.'
            })
          }
        }
      } catch (e) {
        console.log(e)
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      } finally {
        this.progress = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px !important;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
